<h2 mat-dialog-title>Edition pricing overview</h2>
<mat-dialog-content>
  <div class="stairstep-dialog-row" *ngFor="let stairstep of stairsteps | keyvalue">
    <span>{{ stairstep.key }}</span>
    <div>
      <glxy-frequency
        *ngIf="stairstep.value.price && stairstep.value.price > 0"
        [value]="stairstep.value.price | currencyWithoutUSD: currencyCode : 'en-US'"
        [form]="'short'"
        [align]="'end'"
        [frequency]="frequency"
        [size]="'regular'"
      ></glxy-frequency>
      <span *ngIf="!stairstep.value.price || stairstep.value.price === 0">{{ freeLabel }}</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="stairstep-actions-container">
  <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
